import { ArenaModel } from "./arena.model";
import { HoundModel } from "./hound.model";

export class QueueModel {
  id: number;
  chain_id: number;
  name: string;
  queue_id: string;
  entryFee: string;
  startDate: Date;
  endDate: Date;
  totalParticipants: number;
  participants: HoundModel[] = [];
  dbArenaId: number;
  arena: ArenaModel;
  entryFeeCurrency: string;
  alphaDuneFeeCurrency: string;
  alphaDuneFee: string;
  createdAt: Date;
  updatedAt: Date;
  cooldown: number;
  staminaCost: number;
  closed: boolean;
  queue: QueueModel;
  lastCompletion: number;
  speciesAllowed: Array<number>;
  arenaFeeCurrency: string;
  arenaFee: string;
  payments: string;

  constructor(queue: Partial<QueueModel> = {}) {
    this.id = queue.id!;
    this.chain_id = queue.chain_id
    this.name = queue.name;
    this.queue_id = queue.queue_id!;
    this.entryFee = queue.entryFee!;
    this.startDate = queue.startDate!;
    this.endDate = queue.endDate!;
    this.totalParticipants = queue.totalParticipants!;
    this.dbArenaId = queue.dbArenaId!;
    this.arena = new ArenaModel(queue.arena)!;
    this.payments = queue.payments;
    this.entryFeeCurrency = queue.entryFeeCurrency;
    this.alphaDuneFeeCurrency = queue.alphaDuneFeeCurrency;
    this.alphaDuneFee = queue.alphaDuneFee;
    this.createdAt = queue.createdAt;
    this.updatedAt = queue.updatedAt;
    this.closed = queue.closed;
    this.cooldown = queue.cooldown;
    this.staminaCost = queue.staminaCost;
    this.queue = queue.queue;
    this.lastCompletion = queue.lastCompletion;
    this.speciesAllowed = queue.speciesAllowed;
    this.arenaFeeCurrency = queue.arenaFeeCurrency;
    this.arenaFee = queue.arenaFee;

    queue.participants?.forEach(e => {
      this.participants.push(new HoundModel(e));
    });
  }

}
